import React from "react";
import {
    Input, Select,
    Button,
    Space,
    Row,
    Col,
    Checkbox,
    Modal,
    Tooltip,
    Image, DatePicker,
    Dropdown
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import dayjs from "dayjs";
import withRouter from "../withRouter";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import ParentPaymentReportStore from "../store/ParentPaymentStore";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import { decode as base64_decode } from "base-64";
import Excel from "../assets/images/NewDesign/Excel.svg";
import Cookies from "js-cookie";

const { RangePicker } = DatePicker;
const { Option } = Select;

class ParentPaymentReport extends React.Component {
    constructor(props, context) {
        super(props);

        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.parentPaymentReportStore = new ParentPaymentReportStore();

        this.state = {
            loading: false,
            loadData: 0,
            pageSize: 50,
            offset: 0,
            limit: 50,
            pageNo: 1,
            modalVisible: false,
            column: "",
            Notcompany: false,
            fromDate: dayjs().format("YYYY-MM-DD"),
            toDate: dayjs().format("YYYY-MM-DD"),
            searchField: "",
            selectedColumns: [
                {
                    title: context.translate("_PARENT_NAME_"),
                    dataIndex: "parentName",
                    width: 150,
                    ellipsis: { showTitle: true },
                    key: "parentName",
                },
                {
                    title: context.translate("_MOBILE_NO_"),
                    dataIndex: "mobileNo",
                    width: 120,
                    ellipsis: { showTitle: true },
                    key: "mobileNo",
                },
                {
                    title: context.translate("_STUDENT_NAME_"),
                    dataIndex: "studentName",
                    width: 150,
                    ellipsis: { showTitle: true },
                    key: "studentName",
                },
                {
                    title: context.translate("_BUS_SUBSCRIPTION_DATE_"),
                    dataIndex: "busSubscriptionDate",
                    width: 160,
                    ellipsis: { showTitle: true },
                    key: "busSubscriptionDate",
                },
                {
                    title: context.translate("_INVOICE_DATE_"),
                    dataIndex: "invoiceDate",
                    width: 140,
                    ellipsis: { showTitle: true },
                    key: "invoiceDate",
                },
                {
                    title: context.translate("_TOTAL_DAYS_BUS_USED_"),
                    dataIndex: "totalDaysBusUsed",
                    width: 160,
                    ellipsis: { showTitle: true },
                    key: "totalDaysBusUsed",
                },
                {
                    title: context.translate("_PAYMENT_STATUS_"),
                    dataIndex: "paymentStatus",
                    width: 130,
                    ellipsis: { showTitle: true },
                    key: "paymentStatus",
                }
            ],
        };
        this.ExportMenuProps = {
            items: [
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={Excel}
                            ></Image>
                            {context.translate("_EXPORT_AS_EXCEL_")}
                        </div>
                    ),
                    key: "excel",
                },
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={PDF}
                            ></Image>
                            {context.translate("_EXPORT_AS_PDF_")}
                        </div>
                    ),
                    key: "pdf",
                },
            ],
            onClick: (val) => {
                let result = [];
                console.log(this.state.fromDate, " ", this.state.toDate);
                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
                    var getData = {
                        companyId: this.state.companyId,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
                        colList: result.toString(),
                        searchField: this.state.searchField
                    };
                    if (val.key === "excel") {
                        this.parentPaymentReportStore.exportExcel(getData);
                    }
                    if (val.key === "pdf") {
                        this.parentPaymentReportStore.exportpdf(getData);
                    }
                }
            },
        };

        this.newColumns = [...this.state.selectedColumns];
    }
    async componentDidMount() {
        this.setState({ pageSize: 50 });
        await this.setState({ column: this.state.selectedColumns });
        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;
            await this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }
    }

    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        await this.setState({ companyId: comp?.value });
        await this.handleSearch();


    }



    async handleTableChange(pagination, filters, sorter) {
        console.log(pagination);
        await this.setState({
            pageNo: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.showData();
    }

    showData = async () => {
        console.log(this.state.companyId);
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
            console.log(this.state.companyId);
        } else {
            this.setState({ Notcompany: false });
            console.log(this.state.companyId);
        }

        if (!this.state.reportType) {
            this.setState({ Nottype: true });
        } else {
            this.setState({ Nottype: false });
        }

        if (this.state.companyId) {
            this.setState({ Notcompany: false });
            await this.parentPaymentReportStore.loadData({
                offset: (this.state.pageNo - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: this.state.companyId,
                pageNo: this.state.pageNo,
                reportType: this.state.reportType,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                searchField: this.state.searchField,
            });
            await this.setState({ loadData: 1 });
        }
    };

    handleCheckboxChange = async (column) => {
        console.log(column);
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            console.log(filtered);
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
        }
    };
    refreshList = async () => {
        await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
        await this.showData();
    };

    onDateTimeChange = (dates) => {
        if (dates) {
            // const format = "YYYY-MM-DD HH:mm:ss,";
            const format = "YYYY-MM-DD";

            this.setState({
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        } else {
            this.setState({ fromDate: "", toDate: "" });
        }
    };

    selectTypeofDate = (value) => {
        if (value === "3" || value === "2") {
            this.setState({ dateWiseReport: true });
            this.setState({ monthWiseReport: false });
        } else if (value === "1") {
            this.setState({ dateWiseReport: false });
            this.setState({ monthWiseReport: true });
        }
    }
    searchInput = async (e) => {
        const value = e.target.value;
        console.log("values", value)
        if (value.length > 2 || value.length === 0) {

            await this.parentPaymentReportStore.loadData({
                offset: (this.state.pageNo - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: this.state.companyId,
                pageNo: this.state.pageNo,
                reportType: this.state.reportType,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                searchField: this.state.searchField,
            });
            await this.setState({ loadData: 1 });
        }
    };
    render() {
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={20}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={(value) => this.handleChange(value)}
                                    allowClear={true}
                                    style={{ width: 150 }}
                                    status={this.state.Notcompany ? "error" : false}
                                />
                                <Input
                                    value={this.state.searchField ? this.state.searchField : ""}
                                    placeholder={this.context.translate(
                                        "_SEARCH_BY_STUDENT_NAME_"
                                    )}
                                    style={{ width: 200, borderRadius: "25px" }}
                                    onKeyUp={(e) => this.searchInput(e)}
                                    onChange={(e) => {
                                        this.setState({ searchField: e.target.value });
                                    }}
                                />
                                <Select
                                    style={{ width: 150 }}
                                    className="searchInput"
                                    status={this.state.Nottype ? "error" : false}
                                    onSelect={async (value) => {
                                        console.log(value);
                                        await this.setState({ reportType: value, Nottype: false });
                                    }}
                                    onChange={(value) => this.selectTypeofDate(value)}
                                    // placeholder="Type"
                                    placeholder={this.context.translate(
                                        "_FLEET_DASHBORD_NEWPOI_TYPE_"
                                    )}
                                >

                                    <Select.Option value="3">Datewise Report</Select.Option>
                                    <Select.Option value="2">Weekly Report</Select.Option>
                                    <Select.Option value="1">Monthly Report</Select.Option>
                                </Select>
                                {this.state.dateWiseReport && (
                                    <>
                                        <DatePicker
                                            defaultValue={dayjs()}
                                            style={{ width: "150px", borderRadius: "25px" }}
                                            status={this.state.Notdate ? "error" : false}
                                            onChange={(date) => {
                                                if (date === null) {
                                                    this.setState({ fromDate: "" });
                                                } else {
                                                    this.setState({
                                                        fromDate: date.format("YYYY-MM-DD"),
                                                    });
                                                }
                                            }}
                                        // style={{ width: "100%" }}
                                        />
                                        <DatePicker
                                            defaultValue={dayjs()}
                                            style={{ width: "150px", borderRadius: "25px" }}
                                            status={this.state.Notdate ? "error" : false}
                                            onChange={(date) => {
                                                if (date === null) {
                                                    this.setState({ toDate: "" });
                                                } else {
                                                    this.setState({ toDate: date.format("YYYY-MM-DD") });
                                                }
                                            }}

                                        />

                                    </>
                                )}
                                {this.state.monthWiseReport && (
                                    <>
                                        <RangePicker
                                            // placeholder={["From Month", "To Month"]}
                                            format="MM-YYYY"
                                            picker="month"
                                            style={{ borderRadius: "25px" }}
                                            onChange={(val) => {
                                                this.onDateTimeChange(val);
                                            }}
                                            status={this.state.Notdate ? "error" : false}
                                            showTime={{
                                                format: "h:mmA",
                                                defaultValue: [
                                                    dayjs().startOf("day"),
                                                    dayjs().endOf("day"),
                                                ],
                                            }}
                                            defaultValue={[
                                                dayjs().startOf("day"),
                                                dayjs().endOf("day"),
                                            ]}
                                        />
                                    </>
                                )}

                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ pageSize: 50, pageNo: 1 });
                                        this.showData();
                                    }}
                                >
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                            </Space>
                        </Col>
                        <Col span={4}>
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            >
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                <Button
                                    className="downloadExcelButton"
                                    disabled={
                                        this.parentPaymentReportStore?.parentPaymentReport?.length > 0
                                            ? false
                                            : true
                                    }
                                >
                                    <Dropdown
                                        overlayClassName="export-dropdown"
                                        menu={this.ExportMenuProps}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                                alignItems: "center",
                                                marginInlineEnd: "30px",
                                            }}
                                            src={downloadIcon}
                                        ></Image>
                                    </Dropdown>
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        // title="Select Columns"
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {console.log(this.newColumns, "Df")}
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        key={this.state.selectedColumns.length}
                        currentPage={this.state.pageNo}
                        pageSize={this.state.pageSize}
                        total={this.parentPaymentReportStore?.total}
                        columns={this.state.selectedColumns}
                        dataSource={this.parentPaymentReportStore?.parentPaymentReport}
                        loading={this.parentPaymentReportStore?.loading}
                        onChange={this.handleTableChange}

                    />
                </div>
            </>
        );
    }
}
ParentPaymentReport.contextType = StoreContext;
export default observer(withRouter(ParentPaymentReport));
